import { __decorate, __metadata } from "tslib";
import { nameOf, plainToInstanceWithLVS, TransformWithLVS } from '@goparrot/common';
import { HttpException, HttpStatus } from '@nestjs/common';
import { ApiExtraModels, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDefined, IsOptional, ValidateNested } from 'class-validator';
import { SpecialDayTypeEnum, StoreExposeGroup } from '../interface';
import { PatchAbstractStoreScheduleDto } from './PatchAbstractStoreScheduleDto';
import { PatchAbstractStoreSpecialDayDto } from './PatchAbstractStoreSpecialDayDto';
import { PatchStoreClosedSpecialDayDto } from './PatchStoreClosedSpecialDayDto';
import { PatchStoreShortSpecialDayDto } from './PatchStoreShortSpecialDayDto';
let PatchStoreScheduleDto = class PatchStoreScheduleDto {
};
__decorate([
    ApiPropertyOptional({ type: () => PatchAbstractStoreScheduleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchAbstractStoreScheduleDto),
    __metadata("design:type", PatchAbstractStoreScheduleDto)
], PatchStoreScheduleDto.prototype, "weekly", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchAbstractStoreScheduleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchAbstractStoreScheduleDto),
    __metadata("design:type", PatchAbstractStoreScheduleDto)
], PatchStoreScheduleDto.prototype, "dineIn", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], PatchStoreScheduleDto.prototype, "haveDineInHours", void 0);
__decorate([
    ApiPropertyOptional({ oneOf: refs(PatchStoreClosedSpecialDayDto, PatchStoreShortSpecialDayDto), isArray: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsArray({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateNested({ each: true, groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    TransformWithLVS(({ value: inList }) => {
        const outList = [];
        if (!inList || !Array.isArray(inList)) {
            return outList;
        }
        for (const item of inList) {
            let instance;
            switch (item.type) {
                case SpecialDayTypeEnum.CLOSED_DAY:
                    instance = plainToInstanceWithLVS(PatchStoreClosedSpecialDayDto, item, {
                        groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH],
                    });
                    break;
                case SpecialDayTypeEnum.SHORT_DAY:
                    instance = plainToInstanceWithLVS(PatchStoreShortSpecialDayDto, item, {
                        groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH],
                    });
                    break;
                default:
                    throw new HttpException('Validation failed, incorrect specialDay.type', HttpStatus.BAD_REQUEST);
            }
            outList.push(instance);
        }
        return outList;
    }),
    Type(() => PatchAbstractStoreSpecialDayDto, {
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { value: PatchStoreClosedSpecialDayDto, name: SpecialDayTypeEnum.CLOSED_DAY },
                { value: PatchStoreShortSpecialDayDto, name: SpecialDayTypeEnum.SHORT_DAY },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    __metadata("design:type", Array)
], PatchStoreScheduleDto.prototype, "specialDays", void 0);
PatchStoreScheduleDto = __decorate([
    ApiExtraModels(PatchStoreClosedSpecialDayDto, PatchStoreShortSpecialDayDto)
], PatchStoreScheduleDto);
export { PatchStoreScheduleDto };
//# sourceMappingURL=PatchStoreScheduleDto.js.map